var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('step',{ref:"formData",attrs:{"ComponentName":'GCCReceived'}})],1),_c('b-col',{attrs:{"cols":"4"}},[_c('GccDetail',{attrs:{"gccObj":_vm.gccDetail}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }